import React, { useEffect, useState } from "react";
import { Remarkable } from 'remarkable';
import Link from 'next/link';
import ReactPaginate from 'react-paginate';
import CaseStudies from "components/blog/CaseStudies"
import fs from "fs";
import clientPromise from "../../lib/mddb.mjs";
import computeFields from "../../lib/computeFields";

export function Blogslist({ blogs }) {

  const blogsortByDateCreated = blogs.sort((a: { date: string }, b: { date: string }): number => {
    return new Date(b.date).getTime() - new Date(a.date).getTime();
  });

  const blogFiltered = blogsortByDateCreated.filter((data) => {
    const categories = data.categories;
    return categories?.some(categories => categories.includes('Useful Tools'))

  })


  const [item, setItem] = useState(blogFiltered)




  useEffect(() => {
    const md = new Remarkable();
    function readingTime(text) {
      const wpm = 265; //same as medium article
      const words = text.trim().split(/\s+/).length;
      const time = Math.ceil(words / wpm);
      return time;
    }

    const updatedBlogs = item.map((blog) => {
      const div = document.createElement('div');
      div.innerHTML = md.render(blog.source);
      const time = readingTime(div.innerText);
      return { ...blog, readingTime: `${time} min read` };
    });
    setItem(updatedBlogs);
  }, [JSON.stringify(item)]);

  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(6);
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = item.slice(indexOfFirstPost, indexOfLastPost);

  const paginate = ({ selected }) => {
    setCurrentPage(selected + 1);
  };
  return (
    <div className="max-w-8xl min-w-full w-full font-['Inter']">
      <div className="flex flex-col items-center">
        <div>
          <div className="max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-8xl px-4">
            <div className="flex flex-col items-start gap-4 pb-8 w-full mt-16 " >
              <button className="medium-title text-left hover:text-orange-400" onClick={() => { setItem(blogFiltered), setCurrentPage(1) }}>
                Useful Tools
              </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-2 min-w-full mt-8 ">
              {currentPosts.map((blog, key) => (
                <article key={blog.urlPath} className="mt-8 min-w-full shrink-0 group">
                  <div className="grid grid-cols-1 text-start ">
                    <Link href={`../${blog.urlPath}`}>
                      <img src={blog.image} className="lg:h-[19rem] h-[14rem] rounded-lg object-cover w-full shadow-xl" alt="Blog Post Image" />
                    </Link>
                    <div className="flex items-center gap-4 mt-4 text-xs">
                      <div className="text-[#556987] text-sm font-medium uppercase text-orange-400 font-semibold md:font-bold">
                        {blog.categories[0]}
                      </div>
                      <span className="text-gray-500">
                        {blog?.readingTime ? blog.readingTime : "0 min read"}
                      </span>
                    </div>
                    <div className="min-w-full w-full">
                      <Link className="mt-2 h-[4.1rem] min-h-[4.1rem] line-clamp-2 text-[#2A3342] text-2xl font-bold w-full min-w-full group-hover:underline" href={`../${blog.urlPath}`}>{blog.title}</Link>
                    </div>
                    <div className="pt-2 text-justify text-secgray font-regular">{blog.description}</div>
                  </div>
                  <div className="relative mt-8 flex items-center gap-x-4 text-start">
                    <img src={blog.avatarUrl} alt="Author Image" className="h-10 w-10 rounded-full bg-gray-100 object-center object-cover" />
                    <div className="text-sm leading-6">
                      <p className="font-semibold text-maingray">
                        <span className="" />
                        {blog.authors[0]}
                      </p>
                      <time dateTime={blog.created} className="text-secgray">
                        {new Date(blog.created).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                      </time>
                    </div>
                  </div>

                </article>
              ))}
              <ReactPaginate
                onPageChange={paginate}
                pageCount={Math.ceil(item.length / postsPerPage)}
                previousLabel={'Prev'}
                nextLabel={'Next'}
                containerClassName={'pagination'}
                pageLinkClassName={'page-number'}
                previousLinkClassName={'page-number'}
                nextLinkClassName={'page-number'}
                activeLinkClassName={'active-page'}
              />
            </div>
          </div>
        </div >
      </div>
    </div>
  )
}

export default function UsefulTools({ blogs, casestudies }) {
  return (
    <div>
      <section className="flex flex-col items-center justify-center 
    mt-24 md:px-8">
        <div className="flex flex-col gap-5 max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-8xl items-center font-['Inter'] text-center ">
          <h1 className="main-top-title hover:text-orange-400">
            <Link href="/blog">Blog</Link>
          </h1>
          <p className="font-medium text-xl text-[#556987]"></p>
        </div>
        <div className="font-['Inter']">
          <Blogslist blogs={blogs} />
        </div>
        <div className="flex flex-col max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-8xl px-4">
          <CaseStudies casestudies={casestudies} />
        </div>
      </section>
    </div>
  )
}


export async function getStaticProps() {
  const mddb = await clientPromise;

  const blogFiles = await mddb.getFiles({ folder: "blog" });
  const caseStudiesFiles = await mddb.getFiles({ folder: "showcase/case-studies" });

  const blogsMetadataPromises = blogFiles.map(async (b) => {
    const source = fs.readFileSync(b.file_path, { encoding: "utf-8" });

    // TODO temporary replacement for contentlayer's computedFields
    const frontMatterWithComputedFields = await computeFields({
      frontMatter: b.metadata,
      urlPath: b.url_path,
      filePath: b.file_path,
      source,
    });
    return frontMatterWithComputedFields;
  });

  const caseStudiesMetadataPromises = caseStudiesFiles.map(async (b) => {
    const source = fs.readFileSync(b.file_path, { encoding: "utf-8" });

    // TODO temporary replacement for contentlayer's computedFields
    const frontMatterWithComputedFields = await computeFields({
      frontMatter: b.metadata,
      urlPath: b.url_path,
      filePath: b.file_path,
      source,
    });
    return frontMatterWithComputedFields;
  });

  const blogsList = await Promise.all(blogsMetadataPromises);
  const caseStudiesList = await Promise.all(caseStudiesMetadataPromises);



  return {
    props: {
      meta: {
        title: "Useful Tools",
        description: "Blog posts that share experiencies, reviews and thoughts on specific and useful tools.",
        showSidebar: false,
        showToc: false,
        showComments: false,
        showEditLink: false,
        urlPath: "",
      },
      blogs: blogsList,
      casestudies: caseStudiesList,
    },
  };
};
